import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { runtimeEnv } from 'src/environments/env-loader';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-warn-fraud',
  templateUrl: './warn-fraud.component.html',
  styleUrls: ['./warn-fraud.component.scss']
})
export class WarnFraudComponent implements OnInit {
  constructor(private router: Router) {}

  public actualUrl: string = '';

  private _entornoActual: string = '';
  private demo: string = 'https://core.demo.yacare.com/api';
  private prod: string = 'https://core.yacare.com/api';

  ngOnInit() {
    this._entornoActual = runtimeEnv.APIURL;
  }

  entorno(_entornoActual) {
    return this.prod == this._entornoActual;
  }

  public get entornoActual(): boolean {
    return this.entorno(this._entornoActual);
  }
}
